import Flickity from "flickity-fade";

export default class GalleryGrid {
    /**
     * @var {boolean}
     */
    visible = false;

    /**
     * @var {boolean}
     */
    fullScreen = false;

    /**
     * @var {array}
     */
    slides = null;

    /**
     * @var {HTMLElement}
     */
    slider = null;

    /**
     * @var {HTMLElement}
     */
    sliderContainer = null;

    /**
     * @var {string|null}
     */
    activeGallery = null;

    /**
     * @var {boolean}
     */
    showGalleryUi = false;

    /**
     * @var {number}
     */
    fullWidth = 0;

    /**
     * @var {int}
     */
    selectedIndex = 0;

    /**
     * @var {int}
     */
    currentXTransform = 0;

    /**
     * @var {string}
     */
    currentCaption = '';

    /**
     * @var {boolean}
     */
    resetting = false;

    /**
     * @var {HTMLElement}
     */
    video = null;

    /**
     * @var {boolean}
     */
    videoPlaying = false;

    /**
     * @var {string}
     */
    videoTime = "00:00";

    /**
     * @var {number}
     */
    videoProgress = 0;

    /**
     * @var {boolean}
     */
    showVideoControls = false;

    /**
     * @var {string}
     */
    videoSrc = '';

    init() {
        this.setFullWidth();
        this.initSlider();
        this.initVideo();
        
        window.addEventListener("resize", (e) => {
            this.setFullWidth();
            this.slider.resize();
        });

    }

    initVideo() {
        console.log('init video');
        this.video = this.$el.querySelector('video');
        if(!this.video) {
            return;
        }

        this.video.addEventListener('loadedmetadata', () => {
            this.videoSrc = this.video.currentSrc;
        });

        this.video.addEventListener("webkitendfullscreen", () => {
            this.resetGalleries();
            this.video.pause();
            this.videoPlaying = false;
            this.video.src = "";
        });

        this.initVideoTracker();

        
    }

    initVideoTracker() {
        const slider = document.querySelector('input[type="range"]');

        slider.addEventListener("change", () => {
            const percentage = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
            slider.style.setProperty("--progress", `${percentage}%`);
        });
            
    }

    togglePlay() {
        if (this.video.paused) {
            this.video.play();
            this.videoPlaying = true;
        } else {
            this.video.pause();
            this.videoPlaying = false;
        }
    }

    updateProgress() {
        this.videoProgress = (this.video.currentTime / this.video.duration) * 100;
        this.videoTime = this.formatTime(this.video.currentTime);

        const slider = this.$root.querySelector('input[type="range"]');

        const percentage = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
        slider.style.setProperty("--progress", `${percentage}%`);
    }

    setMaxRange() {
        this.$el.querySelector('.range').max = this.video.duration;
    }

    updateVideoTracking(event) {
        const newTime = event.target.value * this.video.duration / 100;
        this.video.currentTime = newTime;
    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
        return `${mins}:${secs}`;
    }

    setActiveGallery(gallery) {
        this.activeGallery = gallery;

        this.slider.resize();

        setTimeout(() => {
            this.showGalleryUi = true;

            if(this.activeGallery == 'video') {
                this.video.src = this.videoSrc;
                console.log(this.video.src);
                this.video.load(); // Important: load the new source.
                this.video.addEventListener('loadedmetadata', () => {
                   this.video.play();
                   this.videoPlaying = true;
                });
            } else {
                this.video.pause();
                this.videoPlaying = false;
            }
        }, 500);
    }

    setFullWidth() {
        const galleryBlockWidth = this.$root.offsetWidth;

        if (galleryBlockWidth > 0) {
            this.fullWidth = galleryBlockWidth;
        }
    }

    setGalleryWidth() {
        if(this.fullScreen) {
            return;
        }

        const activeGalleries = ['video', 'map', 'images'];

        if(!activeGalleries.includes(this.activeGallery) && window.outerWidth < 768) {
            return;
        }

        const containerRect = this.$root.getBoundingClientRect();
        const galleryRect = this.$el.getBoundingClientRect();

        this.currentXTransform = galleryRect.left - containerRect.left;
        this.$el.style.transform = `translateX(-${this.currentXTransform}px)`;

        this.$el.style.width = this.fullWidth + "px";

        if(this.activeGallery == 'map') {
            window.dispatchEvent(new CustomEvent("resizemap"));
        }
    }

    resetGalleries() {
        console.log('reset galleries');
        this.resetting = true;
        this.$root.querySelectorAll(".Gallery__Item").forEach((galleryItem) => {
            galleryItem.style.width = "";
            galleryItem.style.transform = "";
        });

        this.showGalleryUi = false;

        
        window.dispatchEvent(new CustomEvent("resizemap"));
        
        setTimeout(() => {
            this.videoPause();
            this.activeGallery = null;
            this.resetting = false;
        }, 500);
    }

    initSlider() {
        this.sliderContainer = this.$refs.slider;
        this.slides = this.sliderContainer.querySelectorAll(".slide");

        let options = {
            cellAlign: "left",
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            fade: true,
            lazyLoad: true,
            on: {
                ready: () => {
                    window.dispatchEvent(new Event("resize"));
                    this.currentCaption = this.slides[this.selectedIndex].dataset.imageCaption;
                },
                change: () => {
                    this.selectedIndex = this.slider.selectedIndex;
                    this.currentCaption = this.slides[this.selectedIndex].dataset.imageCaption;
                },
            },
        };

        this.slider = new Flickity(this.sliderContainer, options);
    }

    resizeSlider() {
        const galleryHeight = this.$root.offsetHeight;

        this.$root.querySelector(
            ".Images__Gallery .flickity-viewport"
        ).style.height = galleryHeight + "px";

        this.slider.resize();
        this.slider.reposition();
    }

    videoPause() {
        const video = this.$root.querySelector("video");

        if (typeof video == "undefined" || video == null) {
            return;
        }

        video.pause();
    }

    videoPlay() {
        const video = this.$root.querySelector("video");

        if (typeof video == "undefined" || video == null) {
            return;
        }

        video.play();
    }

    detectVideoEnd() {
        const video = this.$el.querySelector("video");

        if (typeof video == "undefined" || video == null) {
            return;
        }

        video.addEventListener("ended", () => {
            this.resetGalleries();
            this.activeGallery = null;
        });
    }

    fullscreenToggle() {
        const element = this.$el.closest(".Gallery__Item");

        if (this.fullScreen) {
            element.style.width = this.fullWidth + "px";
            element.style.height = "";

            const classesToAdd = ["absolute", "fullscreen-start"];
            const classesToRemove = [
                "fixed",
                "top-1/2",
                "left-1/2",
                "z-[99999]",
                "overflow-auto",
                "h-[100vw]",
                "sm:h-[50vw]",
                "md:h-[33vw]",
                "fullscreen-end"
            ];

            setTimeout(() => {
                element.classList.remove(...classesToRemove);
                element.classList.add(...classesToAdd);

                element.style.transform = `translateX(-${this.currentXTransform}px)`;
            }, 450);

            setTimeout(() => {
                element.classList.remove("fullscreen-start");
            }, 500);

            this.fullScreen = false;
        } else {
            const classesToRemove = ["absolute"];
            const classesToAdd = [
                "fixed",
                "top-1/2",
                "left-1/2",
                "z-[99999]",
                "overflow-auto",
                "h-[100vw]",
                "sm:h-[50vw]",
                "md:h-[33vw]",
                "fullscreen-start"
            ];

            element.classList.remove(...classesToRemove);
            element.classList.add(...classesToAdd);

            element.style.transform = "translate(-50%, -50%)";

            setTimeout(() => {
                element.classList.remove("fullscreen-start");
                element.classList.add("fullscreen-end");
                element.style.width = "100%";
                element.style.height = "100%";

            }, 10);

            this.fullScreen = true;
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("galleryGrid", () => new GalleryGrid());
});
